import { lazy } from 'react';
import { withProtected } from './withProtected';

export const resourceHub = [
	{
		path: '/resource-hub',
		Component: withProtected(lazy(() => import('../pages/ResourceHub'))),
		children: [
			{
				path: '/resource-hub/',
				Component: lazy(() => import('../pages/ResourceHub/ResourceHub')),
				handle: {
					key: 'pages.resourceHub.title'
				}
			},
			{
				path: '/resource-hub/my-resources',
				Component: lazy(() => import('../pages/ResourceHub/MyResources')),
				handle: {
					key: 'pages.resourceHub.myResources'
				}
			},
			{
				path: '/resource-hub/:resourceId',
				Component: lazy(() => import('../pages/ResourceHub/ResourceDetail')),
				handle: {
					key: 'pages.resourceHub.detail'
				}
			}
		]
	}
];
